G.SPDM_CompletedSeparator = function(x, y) {
  G.Image.call(this, x, y, "completed_missions_area", 0.5);

  this.text = this.add(new G.Text(0, 0, OMT.language.getText("Completed Missions"), {
    style: "font-white",
    fontSize: 35,
  }, 0.5, 310));
}

G.SPDM_CompletedSeparator.prototype = Object.create(G.Image.prototype);